module.exports = __webpack_public_path__ + "img/menu-bg.495571cc.png";